<h1>School- en studieopdrachten</h1>

Alpacamundo helpt graag iedereen die een opleiding volgt met betrekking tot dieren. 
Wij leren je graag meer over de alpaca. Wij hebben geen volledige stageplaatsen, daar zijn we te klein voor. 
Wat we wel bieden is:

<ul>
    <li>informatie en hulp bij schoolopdrachten, spreekbeurten en presentaties.</li>
    <li>ruimte voor studenten die langdurige opdrachten moeten uitvoeren met een beperkt aantal uren per week (voor bijvoorbeeld Regioleren).</li>
    <li>Onderzoeksopdrachten voor diergerichte opleidingen zoals dierverzorging, diermanagement, dierenarts of paraveterinair.</li>
</ul>
Gezien onze beperkte ruimte ontvangen we alleen kleine groepen tot een maximum van 5 personen. 
Je krijgt daarmee onze volledige persoonlijke aandacht en gericht antwoorden op het doel van je bezoek.
<img src="assets/images/pages/regioleren.jpg" alt="Regioleren">